import MyTextField from "../TextField";
import { FormControl } from "@mui/material";
import MyTextLabel from "../InputLabel";

const FormScreenThree = ({ formData, formErrors, handleChange }) => {
  return (
    <>
      <FormControl
        variant="standard"
        fullWidth
        error={!!formErrors.allergiesError}
      >
        <MyTextLabel shrink htmlFor={"allergies"}>
          Any Allergies You’d Like Us To Know About?
        </MyTextLabel>
        <MyTextField
          id={"allergies"}
          placeholder="Yes"
          value={formData.allergies}
          name="allergies"
          onChange={handleChange}
        />
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        error={!!formErrors.medicalsError}
      >
        <MyTextLabel shrink htmlFor={"medicals"}>
          How About A Medical Condition?
        </MyTextLabel>
        <MyTextField
          id={"medicals"}
          placeholder="none"
          value={formData.medicals}
          name="medicals"
          onChange={handleChange}
        />
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        error={!!formErrors.socialError}
      >
        <MyTextLabel shrink htmlFor={"social"}>
          Drop Link(s) To Your Social Media Handles
        </MyTextLabel>
        <MyTextField
          id={"social"}
          placeholder="@ain_conferences"
          value={formData.social}
          name="social"
          onChange={handleChange}
        />
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        error={!!formErrors.expectationsError}
      >
        <MyTextLabel shrink htmlFor={"expectations"}>
          What Are Your Expectations For This Contest?
        </MyTextLabel>
        <MyTextField
          id={"expectations"}
          placeholder=""
          value={formData.expectations}
          name="expectations"
          onChange={handleChange}
        />
      </FormControl>
    </>
  );
};

export default FormScreenThree;
